import React, { Fragment, useState } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";

export function Select({ items, change = () => {}, defaultValue }) {
  const normalize = (v) => {
    if (!v) return "";
    if (typeof v === "string") return v;
    return `${v.label} - ${v.value}`;
  };
  const [selectedKey, setSelectedKey] = useState(() => normalize(defaultValue));

  const handleChange = (key) => {
    setSelectedKey(key);
    const [label, ...rest] = key.split(" - ");
    const value = rest.join(" - ");
    change({ label, value, key });
  };

  return (
    <div className="w-full sm:w-96">
      <Listbox value={selectedKey} onChange={handleChange}>
        <div className="relative">
          {/* Botón que muestra la selección */}
          <Listbox.Button className="relative w-full cursor-pointer rounded-xl bg-white py-2.5 pl-4 pr-10 text-left border border-slate-200 shadow-xs focus:outline-none focus:ring-4 focus:ring-primary/15 focus:border-primary transition-all text-sm font-semibold text-slate-800 hover:border-slate-300">
            <span className="block truncate">
              {selectedKey || "Seleccione una opción"}
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-slate-400">
              <ChevronUpDownIcon className="h-5 w-5" aria-hidden="true" />
            </span>
          </Listbox.Button>

          {/* Lista desplegable */}
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Listbox.Options className="absolute z-50 mt-2 max-h-72 w-full overflow-auto rounded-2xl bg-white p-1.5 text-sm shadow-card border border-slate-100 focus:outline-none">
              {items.map((item, gi) => (
                <div key={gi} className="mb-2 last:mb-0">
                  {/* Separador (label del grupo) */}
                  <div className="px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-slate-400">
                    {item.label}
                  </div>

                  {item.values.map((value, ti) => {
                    const keyStr = `${item.label} - ${value}`;
                    return (
                      <Listbox.Option
                        key={`${gi}-${ti}`}
                        value={keyStr}
                        className={({ active, selected }) =>
                          `relative cursor-pointer select-none py-2 pl-9 pr-4 rounded-lg transition-colors font-medium ${
                            selected
                              ? "bg-primary-light text-primary font-bold"
                              : active
                                ? "bg-slate-50 text-slate-900"
                                : "text-slate-700"
                          }`
                        }
                      >
                        {({ selected }) => (
                          <>
                            <span className="block truncate">
                              {value}
                            </span>
                            {selected && (
                              <span className="absolute inset-y-0 left-2.5 flex items-center text-primary">
                                <CheckIcon className="h-4 w-4 stroke-[3]" />
                              </span>
                            )}
                          </>
                        )}
                      </Listbox.Option>
                    );
                  })}
                </div>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
}

